<template>
  <div class="flex w-full flex-col items-start">
    <div
      class="my-4 flex h-full min-h-0.5 w-full flex-col rounded-sm p-8 pb-4 pr-0"
      style="background-color: #09161d"
    >
      <div class="max-w-6xl lg:flex lg:items-center lg:justify-between">
        <div class="min-w-0 flex-1">
          <div class="flex items-center justify-between" v-if="creator">
            <Avatar class="h-14 w-14">
              <AvatarFallback>{{ creator.name[0] }}</AvatarFallback>
              <AvatarImage :src="creator.thumbnail" />
            </Avatar>
            <div class="ml-4 flex w-full flex-col justify-center">
              <h2 class="mb-2 text-xl font-medium">
                {{ title }}
              </h2>
              <div class="flex">
                <span class="meta">
                  <span>
                    by
                    <span class="underline">{{ creator.name }}</span>
                  </span>
                </span>

                <span class="meta ml-4">
                  <IconSmartView2 class="h-4 w-4" />
                  <span class="text-neutral-400"
                    >{{ $t("overlay.scenes", 1) }}
                  </span>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <PreviewGallery
        v-if="item"
        :items="gallery"
        @selected="onPreviewSelected"
        is-onboarding
      />
      <UiSkeleton v-else />
    </div>
    <div
      class="grid w-full auto-cols-[160px] grid-flow-col gap-3 overflow-x-auto py-2"
      style="max-width: 44.8rem"
    >
      <LibraryItem
        v-for="(overlay, i) in overlays"
        :key="i"
        class="cursor-default select-none rounded"
        :class="{
          'outline outline-2 outline-primary':
            overlay && overlay.id === selectedOverlayId,
          'cursor-pointer': overlay && overlay.id !== selectedOverlayId,
        }"
        :item="overlay || undefined"
        :hide-additional-images="true"
        :hide-info="true"
        :hide-ultra-icon="true"
        :no-link="true"
        @click="overlay ? (selectedOverlayId = overlay.id) : undefined"
      />
    </div>
  </div>
</template>
<script setup lang="ts">
/* TODO:
  I do not like this component, and there is most certainly a better way to do this,
  specially the handling of the selected theme.
  That said, reactive keys on fetchers aren't working at all, so we do a lot of manual work.
*/
import { useVModel } from '@vueuse/core';

const { t: $t } = useI18n();
const library = useLibraryStore();
const { public: $env } = useRuntimeConfig();
// const { data: bundledItems } = await library.fetchBundledItems(itemId.value);

const gallery = computed(() => {
  return (item.value?.object.media || []).map((media) => media.url);
});

const onPreviewSelected = () => {};

const props = defineProps<{
  selectedOverlayId: number | undefined;
  overlays: LibraryItem[] | null[];
}>();

const emit = defineEmits(['update:paypalEmail']);

const selectedOverlayId = useVModel(props, 'selectedOverlayId', emit);

const overlayUrl = computed(() => {
  const itemId = selectedOverlayId.value;

  return `${$env.MARKETPLACE_ORIGIN}/api/v2/themes/${itemId}`;
});

const { data: item } = useFetch<TsThemesItemOverlay>(overlayUrl, {
  watch: [selectedOverlayId],
});

const title = computed(() => item.value?.name);
const creator = computed(() => item.value?.creator);
</script>

<style scoped lang="scss">
.meta {
  @apply flex items-center space-x-1.5 text-sm text-gray-200;

  svg {
    @apply flex-shrink-0 text-gray-500;
  }
}
</style>
